import React from 'react';

const SIZES = {
  sm: { height: 'var(--control-h-sm)', padding: '0 16px', font: 'var(--text-sm)', radius: 'var(--radius-sm)' },
  md: { height: 'var(--control-h)',    padding: '0 22px', font: 'var(--text-md)', radius: 'var(--radius-md)' },
  lg: { height: '60px',                padding: '0 28px', font: 'var(--text-lg)', radius: 'var(--radius-lg)' },
};

const VARIANTS = {
  primary: {
    background: 'var(--accent)', color: 'var(--accent-contrast)',
    border: '1.5px solid transparent', boxShadow: 'var(--shadow-accent)',
  },
  secondary: {
    background: 'var(--surface-raised)', color: 'var(--text-primary)',
    border: '1.5px solid var(--border-strong)', boxShadow: 'var(--shadow-xs)',
  },
  ghost: {
    background: 'transparent', color: 'var(--text-accent)',
    border: '1.5px solid transparent', boxShadow: 'none',
  },
  danger: {
    background: 'var(--danger)', color: '#fff',
    border: '1.5px solid transparent', boxShadow: '0 6px 18px rgba(178,58,46,.28)',
  },
};

export function Button({
  children, variant = 'primary', size = 'md', fullWidth = false,
  disabled = false, loading = false, iconLeft = null, iconRight = null,
  onClick, type = 'button', style = {}, ...rest
}) {
  const s = SIZES[size] || SIZES.md;
  const v = VARIANTS[variant] || VARIANTS.primary;
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        gap: '10px', width: fullWidth ? '100%' : 'auto',
        height: s.height, padding: s.padding, fontSize: s.font,
        fontFamily: 'var(--font-body)', fontWeight: 'var(--weight-semibold)',
        letterSpacing: 'var(--tracking-tight)', lineHeight: 1,
        borderRadius: s.radius, cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.5 : 1,
        transition: 'transform var(--dur-fast) var(--ease-standard), filter var(--dur-fast) var(--ease-standard), background var(--dur-fast)',
        WebkitTapHighlightColor: 'transparent', userSelect: 'none',
        ...v, ...style,
      }}
      onMouseDown={(e) => { if (!isDisabled) e.currentTarget.style.transform = 'scale(var(--press-scale))'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      {...rest}
    >
      {loading && <Spinner />}
      {!loading && iconLeft}
      {children}
      {!loading && iconRight}
    </button>
  );
}

function Spinner() {
  return (
    <span
      aria-hidden
      style={{
        width: 16, height: 16, borderRadius: '50%',
        border: '2px solid currentColor', borderTopColor: 'transparent',
        display: 'inline-block', animation: 'kor-spin 0.7s linear infinite',
      }}
    />
  );
}
